import { currentLanguage } from "../../../algorithms/storage";
import axios from "../../axiosConfig";

export const addCommentData = (procId, data, token) => {
  return axios.post(
    `TaskComment/AddTaskComment?taskprocedureId=${procId}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getCommentsById = (procId, token) => {
  return axios.get(`TaskComment/GetComments/${procId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getActivityProcedureCommentsById = (procId, token) => {
  return axios.get(`ActivityComment/GetActivityProcedureComments/${procId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const addActivityProcedureCommentData = (procId, data, token) => {
  return axios.post(
    `ActivityComment/AddActivityComment?activityprocedureId=${procId}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
